import React from "react";
import { Modal } from "antd";

export const isVideoMedia = (fileType, fileName) => {
  const mime = String(fileType || "").toLowerCase();
  if (mime.startsWith("video/") || mime === "video/mp4") {
    return true;
  }

  const name = String(fileName || "").toLowerCase();
  return [".mp4", ".3gp", ".mov", ".webm", ".mkv"].some((ext) =>
    name.endsWith(ext)
  );
};

const VIDEO_MAX_HEIGHT = "calc(100vh - 140px)";
const VIDEO_MAX_WIDTH = "min(680px, 92vw)";

const VideoPlayerModal = ({ open, onClose, url, title }) => (
  <Modal
    destroyOnClose
    maskClosable
    open={open}
    onCancel={onClose}
    footer={null}
    centered
    title={title || "Video"}
    width="fit-content"
    style={{ maxWidth: "96vw" }}
    styles={{
      body: {
        padding: "12px 16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      },
    }}
  >
    {url ? (
      <video
        key={url}
        src={url}
        controls
        autoPlay
        playsInline
        style={{
          display: "block",
          maxHeight: VIDEO_MAX_HEIGHT,
          maxWidth: VIDEO_MAX_WIDTH,
          width: "auto",
          height: "auto",
          borderRadius: 8,
          background: "#000",
          objectFit: "contain",
        }}
      />
    ) : null}
  </Modal>
);

export default VideoPlayerModal;
